module.exports = __webpack_public_path__ + "70f20b9d7eece32a2c39b432208297c9.svg";